"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rules = {
    ProgramRoot: 'ProgramRoot',
    Assignment: 'Assignment',
    Each: 'Each',
    IfStatement: 'IfStatement',
    PipeExpression: 'PipeExpression',
    RelationExpression: 'RelationExpression',
    Expression: 'Expression',
    Term: 'Term',
    Factor: 'Factor',
    To: 'To',
    FunctionStatement: 'FunctionStatement',
    BlockStatement: 'BlockStatement',
    ToRight: 'ToRight',
    ParenthesisExpression: 'ParenthesisExpression',
    ReturnStatement: 'ReturnStatement',
    PipeFrom: 'PipeFrom',
    PipeArguments: 'PipeArguments',
    LogicExpression: 'LogicExpression',
    RangeExpression: 'RangeExpression',
    ArrayElement: 'ArrayElement',
};
